import { Link } from "react-router-dom";
import classNames from "classnames";

export const Breadcrumbs = ({ pages = [], isRouting = true }) => {
    const cn = classNames;

    const filteredPages = pages;

    const lastIndex = filteredPages.length - 1;

    const titleStylePattern = "text-xl sm:text-2xl md:text-3xl font-bold";

    return (
        <nav className="flex my-6" aria-label="Breadcrumb">
            <ol role="list" className="flex items-center">
                {filteredPages.map((page, i) => (
                    <li className="flex items-center" key={i}>
                        <div className="h-12 flex items-center">
                            {i !== 0 && <span className="mt-1 text-base sm:text-lg md:text-2xl lg:text-3xl font-bold mx-2">{'>'}</span>}
                            {i !== lastIndex ? (
                                <>
                                    {isRouting ? (
                                        <Link to={page.path} aria-current="true" className="cursor-pointer">
                                            <h1 className={cn('hover:text-gray-500 normal-case', titleStylePattern)}>{page.name}</h1>
                                        </Link>
                                    ) : (
                                        <a href={page.path} aria-current="true" className="cursor-pointer">
                                            <h1 className={cn('hover:text-gray-500 normal-case', titleStylePattern)}>{page.name}</h1>
                                        </a>
                                    )}
                                </>
                            ) : (
                                <h1 className={cn('normal-case cursor-auto', titleStylePattern, { 'text-gray-500': i !== 0 })}>{page.name}</h1>
                            )}
                        </div>
                    </li>
                ))}
            </ol>
        </nav>
    );
};
